import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface IFormInputProps {
  type: string;
  placeholder?: string;
  disabled?: boolean;
}

export default function FormInput(props: WrappedFieldProps & IFormInputProps) {
  const {
    input,
    type,
    placeholder = '',
    disabled = false,
    meta: { touched, error },
  } = props;

  return (
    <>
      <input
        {...input}
        id={input.name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className="form-control"
      />
      {touched && error && <small className="invalid">{error}</small>}
    </>
  );
}
